var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"button button--secondary",attrs:{"active-class":"active","to":{ name: 'dashboard', params: { lang: _vm.$i18n.locale } }}},[_vm._v(" "+_vm._s(_vm.$t("My +442"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }